var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-none d-lg-flex row text-white text-center bg-primary"},_vm._l((_vm.weekdays),function(day){return _c('div',{key:day,staticClass:"col user-select-none p-1"},[_c('strong',[_vm._v(" "+_vm._s(day)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }